import { Injectable } from '@angular/core';
import { NcacheSubscription } from 'src/app/models/ncache-subscription.model';
import { SelfBuyForm } from '../interfaces/selfBuyForm.interface';
import { PurchasePathType } from '../types/purchase-path-type';
import { of } from 'rxjs';
import { HttpService } from 'src/app/http.service';
import { environment } from 'src/environments/environment';
import { NCacheSubscription } from 'src/app/interfaces/subscription.interface';
import { QuotationType } from 'src/app/enums/quotation.enum';

@Injectable({
  providedIn: 'root', // ensures the service is available throughout the application
})
export class FormPersistenceService {
  private _subscription: NcacheSubscription;

  selfBuyForm: SelfBuyForm;
  selectedPath: PurchasePathType;
  customQuotationId: string = ''; 
  subscriptionId: string | undefined;
  editQuotationFlow: boolean = false;
  isQuotationAnnualEnvFlowActive: boolean = false;
  isQuotationAnnualServerFlowActive: boolean = false;
  isMidYear:boolean = false
  private quotationType:QuotationType = QuotationType.Annual

  constructor(private readonly http: HttpService) {
    this.selfBuyForm = new SelfBuyForm();
  }

  getSubscriptionDetails(subscriptionId: string) {
    return this.http.get<NCacheSubscription>(environment.api.routes.subscription.get_subscription_detail, { Id: subscriptionId })
  }

  get ncacheSubscription() {
    return this._subscription;
  }

  unsetSubscription() {
    this._subscription = null;
  }

  set setQuotationType(quotationType:QuotationType){
    this.quotationType  = quotationType 
  }
  get getQuotationType(){
    return this.quotationType
  }
}
